<template>
    <div :style="'background:' + skins.main_color_1">
        <div v-if="skin_charged && translation.competitions" style="color: white; position: relative;"
            :style="{ padding: screen_width <= 768 ? '2px' : '0 10px' }">
            <div>
                <upper-header class="sticky-header" v-bind:skin="selected_skin" v-bind:language="language"
                    v-bind:translation="translation" @login-upper-header="login"
                    @register-upper-header="register"></upper-header>
            </div>
            <div class="main-header-section">
                <main-header v-bind:skin="selected_skin" v-bind:language="language" v-bind:translation="translation"/>
                <div class="modal-container" v-if="displayModal">
                    <div class="modal-root">
                        <my_account v-bind:skin="selected_skin" v-bind:language="language"
                            v-bind:translation="translation">
                        </my_account>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import mainHeader from "./MainHeader.vue";
import router from "@/router/index";
import UpperHeader from "./UpperHeader.vue";
import { mapState } from 'vuex';
import my_account from "./my_account.vue";

export default {
    name: "Main",
    components: {
        my_account,
        UpperHeader,
        mainHeader
    },
    data() {
        return {
            tabSeleccionada: null,
            tabs: [
                { name: "todos", label: "Todos", color: "aqua" },
                { name: "1hh", label: "Eventos en 1 Hora", color: "red" },
                { name: "3hh", label: "Eventos en 3 Hora", color: "yellow" },
                { name: "hoy", label: "Eventos Hoy", color: "green" },
                { name: "hoy1", label: "Mañana", color: "blue" },
            ],
            isLoading: true,
            displayModal: false,
            timeLineContainerShow: true,
            tabSeleccionada: null,
            showCuponApuestas: false,
            showDeporte: true,
            showLigas: false, // Controla la visibilidad de ligas-prematch-container
            showEncuentroData: false, // Controla la visibilidad de encuentro-data-container
            message: "",
            sports_loaded: false,
            screen_width: 0,
            follow_id: "",
            flag: "es",
            debug: false,
            prematch_evento_data: {},
            prematch2_gameData: {},
            sport_selected: {},
            casino_brand_selected: "0-pragmatic",
            casino_frame: "",
            next_label: "<span style='color:white;'>▶</span>",
            prev_label: "<span style='color:white;'>◀</span>",
            refreshHeight: 0,
            casinoUserId: "655d4ae63ad36797f65fabad",
            tabsNavigationHistory: [],
        };
    },
    computed: {
        ...mapState({
            skins: state => state.skins[0],    // Mapea `state.user` a `user` en el componente
            counter: state => state.counter // Mapea `state.counter` a `counter` en el componente
        }),
        market() {
            let data = this.$store.getters["prematch_2/getSuscribeEventsMarket"];
            if (data[this.$props.game.id] != null) {
                let game =
                    data[this.$props.game.id].data.data.sport[this.$props.sport].region[
                        this.$props.game.country_id
                    ].competition[this.$props.game.liga_id].game[this.$props.game.id];
                alert(game);
                return game;
            }
            return {};
        },
        target_event_loaded() {
            return this.$store.getters["live/getLoadedEventData"];
        },
        selected_skin() {
            return this.$store.getters["getCurrentSkin"];
        },
        contentHeight() {
            this.refreshHeight;
            let header_height = this.$store.getters["getHeaderHeight"];
            let screen_height = window.innerHeight;
            return screen_height - header_height + "px";
        },
        headerHeight() {
            return this.$store.getters["getHeaderHeight"] + "px";
        },
        config() {
            return this.$store.getters["getConfig"];
        },
        lobbyView() {
            return this.$store.getters["getLobbyView"];
        },
        prematchTarget() {
            return this.$store.getters["getPrematchTarget"];
        },
        can_bet() {
            let data = this.$store.getters["getCanBet"];
            return data;
        },
        selected_skin() {
            return this.$store.getters["getCurrentSkin"];
        },
        skin_charged() {
            return this.$store.getters["getSkinCharged"];
        },
        language() {
            return this.$store.getters["getLanguage"];
        },
        sports_live() {
            return this.$store.getters["live/getSports"];
        },
        sports_prematch() {
            // console.log(this.$store.getters["prematch_2/getSports"]);
            return this.$store.getters["prematch_2/getSports"];
        },
        favoritos() {
            return this.$store.getters["live/getFavorites"];
        },
        target_event() {
            if (Object.keys(this.$store.getters["live/getLiveEvent"]).length > 0) {
                return this.$store.getters["live/getLiveEvent"].data.data.sport;
            }
            return false;
        },
        translation() {
            return this.$store.getters.getTranslation;
        },
        time() {
            return this.$store.getters["prematch/getTime"];
        },
        timeLoading() {
            return this.$store.getters["prematch_2/getTimeLoading"];
        },
        view() {
            return this.$store.getters["getView"];
        },
        user() {
            let data = this.$store.getters["getUserData"];
            return data;
        },
        bet_counter() {
            let count = 0;
            let data = this.$store.getters["getBets"];
            Object.keys(data).forEach((element) => {
                if (data[element]) {
                    count++;
                }
            });
            let bar = document.getElementById("navbarToggleExternalContent");
            if (count < 1 && bar) {
                bar.classList.remove("show");
            }
            return count;
        },
    },
    created() {
        this.sizeControl();
        let self = this;
        document.addEventListener("keydown", function (event) {
            if (event.ctrlKey && event.key === "j") {
                self.debug = !self.debug;
            }
        });
        let balanceRequestTime = 60000;
        let formated = router.currentRoute.query.target;
        if (formated) {
            if (formated.includes("-")) {
                if (formated.split("-")[2] != "integration") {
                    balanceRequestTime = 10000;
                }
            }
        }
        var saldo_request = setInterval(function () {
            try {
                if (self.$store.getters["getUserData"].user_data.data) {
                    self.$store.dispatch("getUserData", {
                        token: self.user.token,
                        site_id: self.user.site_id,
                        site: self.user.site,
                        prefix: self.user.prefix,
                        source: "main",
                    });
                }
            } catch (error) {
                this.$store.dispatch("logOut");
                this.$root.$emit("forceRender");
                clearInterval(saldo_request);
            }
        }, balanceRequestTime);
    },
    watch: {},
    mounted() {
        this.$root.$on("open-my-account-modal", () => {
            this.displayModal = !this.displayModal;
        });
        window.addEventListener("resize", () => {
            this.sizeControl();
        });
        // window.addEventListener(
        //     "message",
        //     (event) => {
        //         if (event.data.view == "casino_live") {
        //             if (this.user.token == "") {
        //                 this.login();
        //             } else {
        //                 this.$store.dispatch("setView", event.data.view);
        //                 this.casino_frame = this.selected_skin.casinolive_lobby?.url ?? "";
        //             }
        //         } else if (event.data.view == "bingo") {
        //             if (this.user.token == "") {
        //                 this.login();
        //             } else {
        //                 this.$store.dispatch("setView", "bingo");
        //                 this.casino_frame =
        //                     this.selected_skin.casinoN_config.url +
        //                     "?token=" +
        //                     this.user.token +
        //                     this.user.site_id +
        //                     "&site=" +
        //                     this.user.site +
        //                     "&lang=" +
        //                     this.language +
        //                     "&currency=" +
        //                     this.user.user_data.data.currency +
        //                     "&view=bingo";
        //             }
        //         } else if (event.data.view == "crazywin") {
        //             if (this.user.token == "") {
        //                 this.login();
        //             } else {
        //                 this.$store.dispatch("setView", "crazzyWin");
        //                 this.casino_frame =
        //                     this.selected_skin.casinoN_config.url +
        //                     "?token=" +
        //                     this.user.token +
        //                     this.user.site_id +
        //                     "&site=" +
        //                     this.user.site +
        //                     "&lang=" +
        //                     this.language +
        //                     "&currency=" +
        //                     this.user.user_data.data.currency +
        //                     "&view=crazzyWin";
        //             }
        //         } else if (event.data.view == "casino_live-pragmaticplay") {
        //             if (this.user.token == "") {
        //                 this.login();
        //             } else {
        //                 this.$store.dispatch("setView", "casino_live");
        //                 this.casino_frame =
        //                     this.selected_skin.casinoLive_config.casino_url +
        //                     "&token=" +
        //                     this.user.token +
        //                     this.user.site_id +
        //                     "-" +
        //                     this.user.site +
        //                     "&playerId=" +
        //                     this.user.user_data.data.id +
        //                     "_" +
        //                     this.user.site_id +
        //                     "&language=" +
        //                     this.language +
        //                     "&currency=" +
        //                     this.user.user_data.data.currency +
        //                     "&viewId=" +
        //                     this.selected_skin.casinoLive_config.pragmaticLive;
        //             }
        //         } else if (event.data.view == "casino_live-ezugi") {
        //             if (this.user.token == "") {
        //                 this.login();
        //             } else {
        //                 this.$store.dispatch("setView", "casino_live");
        //                 this.casino_frame =
        //                     this.selected_skin.casinoLive_config.casino_url +
        //                     "&token=" +
        //                     this.user.token +
        //                     this.user.site_id +
        //                     "-" +
        //                     this.user.site +
        //                     "&playerId=" +
        //                     this.user.user_data.data.id +
        //                     "_" +
        //                     this.user.site_id +
        //                     "&language=" +
        //                     this.language +
        //                     "&currency=" +
        //                     this.user.user_data.data.currency +
        //                     "&viewId=" +
        //                     this.selected_skin.casinoLive_config.ezugiLive;
        //             }
        //         } else if (event.data.view == "casino_live-vivogaming") {
        //             if (this.user.token == "") {
        //                 this.login();
        //             } else {
        //                 this.$store.dispatch("setView", "casino_live");
        //                 this.casino_frame =
        //                     this.selected_skin.casinoLive_config.casino_url +
        //                     "&token=" +
        //                     this.user.token +
        //                     this.user.site_id +
        //                     "-" +
        //                     this.user.site +
        //                     "&playerId=" +
        //                     this.user.user_data.data.id +
        //                     "_" +
        //                     this.user.site_id +
        //                     "&language=" +
        //                     this.language +
        //                     "&currency=" +
        //                     this.user.user_data.data.currency +
        //                     "&viewId=" +
        //                     this.selected_skin.casinoLive_config.vivogamingLive;
        //             }
        //         } else if (event.data.view == "hipicas") {
        //             if (this.user.token == "") {
        //                 this.login();
        //             } else {
        //                 if (this.selected_skin.hipicas_config?.provider == "jbets") {
        //                     const url =
        //                         this.selected_skin.hipicas_config.url +
        //                         "&token=" +
        //                         this.user.token +
        //                         this.user.site_id +
        //                         "-" +
        //                         this.user.site +
        //                         "&playerId=" +
        //                         this.user.user_data.data.id +
        //                         "_" +
        //                         this.user.site_id +
        //                         "&language=" +
        //                         this.language +
        //                         "&currency=" +
        //                         this.user.user_data.data.currency;
        //                     window.open(url, "_blank");
        //                 } else {
        //                     const url =
        //                         this.config.SkinCConfig.racing.horse.url +
        //                         "?tokenUser=" +
        //                         this.user.token +
        //                         this.user.site_id +
        //                         "&tokenClient=72b0fc93-fdd1-4c08-b1fd-0be81726a5d2&lang=es&cashierUrl=" +
        //                         this.user.domain +
        //                         "&homeUrl=" +
        //                         this.user.domain;
        //                     window.open(url, "_blank");
        //                 }
        //                 // this.$store.dispatch('setView','hipicas');
        //             }
        //         } else if (event.data.view == "main") {
        //             this.$store.dispatch("setLobbyView", "prematch2_ligas");
        //             this.$store.dispatch("setView", event.data.view);
        //         } else if (event.data.view == "register") {
        //             this.register();
        //         } else if (event.data.view == "poker") {
        //             if (this.user.token == "") {
        //                 this.login();
        //             } else {
        //                 this.$store.dispatch("setView", event.data.view);
        //             }
        //         } else if (event.data.view == "casino") {
        //             if (this.user.token == "") {
        //                 this.login();
        //             } else {
        //                 this.$store.dispatch("setView", event.data.view);
        //                 // const iframe = document.getElementById("casinoViewIframe")
        //                 // if(iframe){
        //                 //     const alturaContenido = iframe.contentWindow.document.body.scrollHeight;
        //                 //     iframe.style.height = alturaContenido + 'px';
        //                 // }
        //             }
        //         } else if (event.data.view == "open_game") {
        //             this.select_event(event.data.gameData);
        //         }
        //     },
        //     false
        // );
        this.$root.$on("show_prematch_ligas", (type) => {
            if (type == 1) {
                this.$store.dispatch("prematch/delete_all_ligas");
            }
        });
        if (
            this.$store.getters["getsearchFromLiveToPrematchRoutingAct"] === true &&
            this.screen_width >= 769 &&
            this.screen_width <= 1399
        ) {
            this.prematch2_gameData = this.$store.getters["getDataDetalleGame"];
            this.$store.dispatch("prematch_2/unsuscribe_all_events");
            if (!("mode" in this.$store.getters["getPayloadDesdeLiveBuscar"])) {
                this.$store.dispatch(
                    "prematch_2/suscribe_event",
                    this.$store.getters["getIdDesdeLiveBuscar"]
                );
            }
            this.$store.dispatch(
                "prematch_2/suscribe_event",
                this.$store.getters["getIdDesdeLiveBuscar"]
            );
            this.$store.dispatch(
                "prematch_2/add_remove_liga",
                this.$store.getters["getPayloadDesdeLiveBuscar"]
            );
            this.$store.dispatch(
                "prematch_2/suscribe_event",
                this.$store.getters["getIdDesdeLiveBuscar"]
            );
            // this.$root.$emit('show_prematch2_event', this.$store.getters["getPayloadDesdeLiveBuscar"]);
        }
        if (
            this.screen_width <= 768 &&
            this.$store.getters["getSearchLivePreResp"] === true
        ) {
            // console.log("Viene buscando desde liv un evento en prematch");
            let payload = this.$store.getters["getPayloadBuscarPrematch"];
            this.$store.dispatch("prematch_2/add_remove_liga", payload);
            this.showLigas = true;
            this.$store.dispatch("setSearchLiveToPrematchResp", false);
        }

        this.$root.$on("select_sport", (data) => {
            this.sport_selected = data;
        });
        this.$root.$on("set_prematch_event", (data) => {
            this.prematch_evento_data = { data: data.data, id: data.id };
        });
        this.$root.$on("show_prematch2_event", (data) => {
            this.prematch2_gameData = data;
        });
        this.$root.$on("emited-evento-liga-prematch-resp", (data) => {
            this.showLigas = true;
            this.showDeporte = false;
        });
        this.$root.$on("emited-encuentro-prematch-resp", (data) => {
            this.showEncuentroData = true;
            this.showDeporte = false;
        });
        this.$root.$on("display-search-input-responsive", (data) => {
            this.timeLineContainerShow = !this.timeLineContainerShow;
        });
        if (this.screen_width >= 769) {
            if (
                this.$store.getters["getSearchFromLiveToPrematchRoutingAct1400"] ==
                true
            ) {
                let storeId = this.$store.getters["getId1400"];
                let storePayload = this.$store.getters["getPayload1400"];
                this.check = !this.check;
                let payload = {
                    league: storePayload.league,
                    country: storePayload.country,
                    league_name: storePayload.league_name,
                    country_name: storePayload.country_name,
                    sport_id: storePayload.sport_id,
                    sport_name: storePayload.sport_name,
                };
                this.suscribePremathEvent(storeId);
                this.$store.dispatch("prematch_2/add_remove_liga", payload);
                // this.$store.dispatch("setStepSpinnerAct", false);
            }
            else {
                let payload = {
                    league: 538,
                    country: 2570001,
                    league_name: "Premier League",
                    country_name: "Inglaterra",
                    sport_id: 1,
                    sport_name: "Futbol",
                };
                this.$store.dispatch("prematch_2/add_remove_liga", payload);
            }
            this.$store.dispatch("setSearchLiveToPrematchResp", false);
        }
    },
    beforeDestroy() {
        this.$root.$off("emited-evento-liga-prematch-resp");
        this.$root.$off("emited-encuentro-prematch-resp", (data) => {
            this.showEncuentroData = false;
        });
        this.$root.$off("display-search-input-responsive");
    },
    methods: {
        closeCouponApuestas() {
            if (this.tabSeleccionada == "coupon") {
                this.showCuponApuestas = false;
            }
        },
        manageTabSelected(item) {
            this.tabSeleccionada = item;
            if (this.tabSeleccionada == "coupon") {
                this.showCuponApuestas = true;
            }
            // console.log("history ==================> ", this.tabsNavigationHistory);
        },
        hideEncuentroData() {
            this.timeLineContainerShow = true;
            this.showEncuentroData = false;
            this.$root.$emit("clean-encuentro-prematch-resp", null);
            this.$store.dispatch("setSetIdDetalleBuscadoAct", null);
            this.showDeporte = true;
        },
        hideEventsLigas() {
            this.showLigas = false;
            this.showDeporte = true;
            this.$store.dispatch("setPayLoadBuscarAct", null);
        },
        set_bets() {
            this.$store.dispatch("setCanBet");
        },
        close_socket() {
            this.$store.dispatch("closeSocket");
        },
        follow() {
            this.$store.dispatch("live/setFollowId", this.follow_id);
            this.follow_id = "";
        },
        sizeControl() {
            this.screen_width = window.innerWidth;
            this.refreshHeight++;
        },
        select_casino(target, id) {
            let parameters = "";
            if (typeof target.parameters === "object") {
                Object.keys(target.parameters).forEach((param) => {
                    parameters += "&" + param + "=" + target.parameters[param];
                });
            }
            this.casino_frame = target.url + "?token=" + this.user.token + parameters;
            let previus = this.casino_brand_selected.toString();
            this.casino_brand_selected = id;
            this.hover2(previus);
        },
        hover1(id) {
            document.getElementById(id).style.backgroundColor =
                this.selected_skin.prematch_all_odds.hover_fondo;
            document.getElementById(id).style.color =
                this.selected_skin.prematch_all_odds.hover_text;
        },
        hover2(id) {
            if (id != this.casino_brand_selected && document.getElementById(id)) {
                document.getElementById(id).style = this.selected_skin.casino.button;
            }
        },
        translate(text) {
            if (this.translation[text]) {
                return this.translation[text][this.language];
            }
            return text;
        },
        login() {
            document.getElementById("login_btn").click();
        },
        register() {
            document.getElementById("register_btn").click();
        },
        async select_event(game) {
            try {
                let event_data = null;
                let isLive = false;
                let event_data_prematch = await this.$store.dispatch(
                    "prematch_2/getPrematchEvent",
                    { game_id: parseInt(game.game_id), sport_id: game.sport_id }
                );
                if (event_data_prematch) {
                    event_data_prematch.sport = game.sport_id;
                    event_data_prematch.liga = game.competition_name;
                    event_data_prematch.sport_alias = game.sport_name;
                    event_data = event_data_prematch;
                } else {
                    let event_data_live = await this.$store.dispatch(
                        "live/getLiveEvent",
                        { game_id: parseInt(game.game_id), sport_id: game.sport_id }
                    );
                    if (event_data_live) {
                        event_data = event_data_live;
                        isLive = true;
                    }
                }
                if (event_data) {
                    if (!isLive) {
                        if (
                            router.history.current.name === "Live_ecuabets" ||
                            router.history.current.name === "LiveMainEcuabets"
                        ) {
                            router.push({
                                name: "Main_ecuabets",
                                query: { token: this.user.token + this.user.site_id },
                            });
                            let self = this;
                            setTimeout(function () {
                                event_data.sport = game.sport_id;
                                self.$store.dispatch("setView", "main");
                                self.$store.dispatch("setLobbyView", "prematch2_evento");
                                self.$root.$emit("show_prematch2_event", event_data);
                                self.$store.dispatch("prematch_2/unsuscribe_all_events");
                                self.$store.dispatch(
                                    "prematch_2/suscribe_event",
                                    parseInt(game.game_id)
                                );
                            }, 100);
                        } else {
                            this.$store.dispatch("setView", "main");
                            this.$store.dispatch("setLobbyView", "prematch2_evento");
                            this.$root.$emit("show_prematch2_event", event_data);
                            this.$store.dispatch("prematch_2/unsuscribe_all_events");
                            this.$store.dispatch(
                                "prematch_2/suscribe_event",
                                parseInt(game.game_id)
                            );
                        }
                    } else {
                        if (
                            router.history.current.name !== "Live_ecuabets" &&
                            router.history.current.name !== "LiveMainEcuabets"
                        ) {
                            router.push({
                                name: "Live_ecuabets",
                                query: { token: this.user.token + this.user.site_id },
                            });
                            let self = this;
                            setTimeout(function () {
                                if (
                                    Object.keys(self.$store.getters["live/getLiveEvent"]).length >
                                    0
                                ) {
                                    self.$store.dispatch("live/unsuscribe_event");
                                }
                                self.$store.dispatch(
                                    "live/suscribe_event",
                                    parseInt(game.game_id)
                                );
                            }, 100);
                        }
                        if (this.$store.getters["live/getTargetEventId"] != game.game_id) {
                            if (
                                Object.keys(this.$store.getters["live/getLiveEvent"]).length > 0
                            ) {
                                this.$store.dispatch("live/unsuscribe_event");
                            }
                            this.$store.dispatch(
                                "live/suscribe_event",
                                parseInt(game.game_id)
                            );
                        }
                    }
                    if (document.getElementById("myAccountCloseBtn")) {
                        document.getElementById("myAccountCloseBtn").click();
                    }
                }
            } catch (error) {
                console.log(error);
            }
        },
        select_time(time) {
            // this.selectedOption = optionUI; // Actualiza la opción seleccionada
            // this.isMenuOpen = !this.isMenuOpen;
            let timer = {
                "1hh": {
                    "@now": {
                        "@gte": 0,
                        "@lt": 3600,
                    },
                },
                "3hh": {
                    "@now": {
                        "@gte": 0,
                        "@lt": 10800,
                    },
                },
                hoy: {
                    "@now": {
                        "@gte": 0,
                        "@lt": 57600,
                    },
                },
                hoy1: {
                    "@now": {
                        "@gte": 57600,
                        "@lt": 144000,
                    },
                },
                todos: {},
            };
            this.$store.dispatch("prematch_2/select_time", {
                name: time,
                timer: timer[time],
            });
        },
    },
};
</script>
<style>
.sticky-header {
  top: 0;
  position: sticky;
  z-index: 6;
  background: #18242f;
}
.modal-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5); /* Fondo semitransparente */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2; /* Asegura que esté sobre otros elementos */
}

.modal-root {
  border-radius: 8px;
  width: 100%;
  max-width: 100%; /* Establece un ancho máximo fijo */
  height: 90%; /* Altura fija relativa al viewport */
  overflow-y: auto; /* Activa scroll cuando el contenido excede la altura fija */
  transform: scale(0.9);
  animation: modalAppear 0.3s ease-out forwards;
}
</style>